import { Suspense } from "react";
import { Announcement } from "components/alerts/InfoBar";
import { AvSignupInfoBar } from "@/components/alerts/AvSignupInfoBar/AvSignupInfoBar";
import { useAvSignupBanner } from "@/components/alerts/AvSignupInfoBar/useAvSignupBanner";

export const AppNotification = () => {
  const avBanner = useAvSignupBanner();

  if (avBanner) {
    return <AvSignupInfoBar {...avBanner} />;
  }

  return (
    <Suspense>
      <Announcement />
    </Suspense>
  );
};
